import { IAppState } from '../../redux';
import { selectActiveService } from './selectActiveService';

export function selectIsSubscriptionSelected(state: IAppState): boolean {
  const selectedService = selectActiveService(state);

  if (!selectedService) {
    return false;
  }

  return selectedService.id === 'servicePackage';
}
